import React, { Component } from 'react';
import './Partner.css';
import Parser from "html-react-parser";
import Moment from 'react-moment';
import 'moment/locale/fr';
import Comments from "./Comments.container";

const partners = require('../res/partners.json');

class Partner extends Component {

    constructor(props) {
        super(props);
    }

    componentWillMount() {
        // this.props.loadPartner(this.props.match.params.label);
    }

    shouldComponentUpdate(nextProps) {
        if (nextProps.partner.error) {
            nextProps.history.push('accueil/1');
        }
        return true;
    }

    componentWillUnmount() {
        this.props.clearPartner();
    }

    render() {
        // const { partner } = this.props;
        const { label } = this.props.match.params;

        const partner = partners.find(r => r.label === label)

        return (
            Object.keys(partner).length > 1 ?
                <div className="partner">
                    <div className="partner-header">
                        {partner.title}
                    </div>
                    <div className="partner-description">
                        <div>{Parser(partner.description)}</div>
                    </div>
                    <div className="partner-footer">
                        Publié le <Moment format="DD MMMM YYYY">{partner.date}</Moment> par {partner.author}
                    </div>
                    {/*<Comments comments={partner.comments} totalComments={partner.totalComments} partnerId={partner.id} partnerLabel={partner.label} />*/}
                </div> : null
        );
    }
}

export default Partner;



// WEBPACK FOOTER //
// ./src/components/Partner.js